module.exports = __webpack_public_path__ + "static/img/2.4cb1d76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/frede/2.jpg
// module id = 1vrf
// module chunks = 0